export default __webpack_public_path__ + "static/media/deathsgaze.2601297d.png";